var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFillForm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8599 5.875H17.3599C17.7577 5.875 18.1392 6.03889 18.4205 6.33061C18.7018 6.62233 18.8599 7.018 18.8599 7.43056V18.3194C18.8599 18.732 18.7018 19.1277 18.4205 19.4194C18.1392 19.7111 17.7577 19.875 17.3599 19.875H8.35986C7.96204 19.875 7.58051 19.7111 7.2992 19.4194C7.0179 19.1277 6.85986 18.732 6.85986 18.3194V7.43056C6.85986 7.018 7.0179 6.62233 7.2992 6.33061C7.58051 6.03889 7.96204 5.875 8.35986 5.875H9.85986",
    stroke: "#092682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1099 4.125H10.6099C10.411 4.125 10.2202 4.20402 10.0795 4.34467C9.93888 4.48532 9.85986 4.67609 9.85986 4.875V6.375C9.85986 6.57391 9.93888 6.76468 10.0795 6.90533C10.2202 7.04598 10.411 7.125 10.6099 7.125H15.1099C15.3088 7.125 15.4995 7.04598 15.6402 6.90533C15.7808 6.76468 15.8599 6.57391 15.8599 6.375V4.875C15.8599 4.67609 15.7808 4.48532 15.6402 4.34467C15.4995 4.20402 15.3088 4.125 15.1099 4.125V4.125Z",
    stroke: "#092682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8599 12L11.8599 16",
    stroke: "#092682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85986 14L11.8599 16",
    stroke: "#092682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillForm);
export default __webpack_public_path__ + "static/media/FillForm.460b84d933e90ecba3e6a3e69ff55b14.svg";
export { ForwardRef as ReactComponent };